import React, { Component } from 'react';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';

import { FormattedMessage, intlShape } from 'react-intl';

class CallMetadataForm extends Component {
  static contextTypes = {
    intl: intlShape.isRequired,
  }

  render() {
    const metadata = this.props.callMetadata;
    const elements = Object.keys(metadata).map(k => {
      const metadataField = this.props.callMetadata[k];
      const value = this.props.callMetadataValues[k];
      
      const items = metadataField.values[this.props.locale].map((text, ix) => {
        const intlMessageId = "metadata." + k + ".values." + ix;
        return <MenuItem checked={value == ix} value={ix} key={ix} primaryText={<FormattedMessage
          id={intlMessageId}
        />} />
      });

      return <ListItem
        leftIcon={<metadataField.icon color="inherit" />}
        key={k}
        disabled={true}>
        <p style={{marginTop: 0}}>
          <FormattedMessage
            id={"metadata." + k + ".title"}
          />
        </p>
        <SelectField
          value={value}
          multiple={metadataField.type === 'multiple'}
          onChange={(e, ix, v) => this.props.onChange(k, v)}
        >
          {items}
        </SelectField>
      </ListItem>;
    });

    return (
      <List className="callmetadata">
        {elements}
      </List>
    )
  }
};

export default CallMetadataForm;


// WEBPACK FOOTER //
// ./src/CallMetadataForm.js